import { VariantProps, cva } from 'class-variance-authority';
import { HtmlHTMLAttributes, FC } from 'react';

import { Loading as LoadingIcon } from '../icons';
import { cn } from '../../utils';

const loadingVariants = cva('animate-spin', {
  variants: {
    size: {
      small: 'size-10',
      medium: 'size-20',
      large: 'size-30',
    },
  },
  defaultVariants: {
    size: 'medium',
  },
});

export interface LoadingProps
  extends HtmlHTMLAttributes<HTMLDivElement>,
    VariantProps<typeof loadingVariants> {
  isLoading?: boolean;
  element?: 'section' | 'main' | 'div';
}

export const Loading: FC<LoadingProps> = ({
  element = 'section',
  isLoading = true,
  className,
  children,
  size,
  ...props
}) => {
  const Comp = element || 'section';
  return isLoading ? (
    <Comp className={cn('flex justify-center items-center w-full p-12', className)} {...props}>
      <LoadingIcon className={cn(loadingVariants({ size }))} />
    </Comp>
  ) : (
    children
  );
};
